export default "__VITE_ASSET__d04add2b__"